import { render } from "./UPDATE_TASK.vue?vue&type=template&id=1bb4fecf&ts=true"
import script from "./UPDATE_TASK.vue?vue&type=script&lang=ts"
export * from "./UPDATE_TASK.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__